/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { useTranslation } from 'react-i18next'
import { TBuyerType } from '@/pages/contract/interface'

export function BuyerType(
  props: React.PropsWithoutRef<{
    buyerType: TBuyerType
  }>,
) {
  const { buyerType } = props
  const { t } = useTranslation()

  return buyerType === TBuyerType.E ? t('buyer_type_enterprise') : t('buyer_type_person')
}
